import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import "Assets/css/error.css"

const CommErrorUi = ({errorCd}:any) => {
    const { data: langData }: any = UseLangLstQuery();
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getErrorCd = query.get("error_cd");
    if(getErrorCd !=null) {
        errorCd = getErrorCd;
    }

    if(errorCd == null) {
        errorCd ="404"
    }
    let contentsTitl = "";

    switch(errorCd) {
        case "403":
            contentsTitl = "Forbidden";
            break
        case "404":
            contentsTitl = "Page not found";
            break;
        case "503":
            contentsTitl = "Service Unavailable";
            break;
        case "502":
            contentsTitl ="Bad Gateway";
            break;
        case "500":
            contentsTitl = "Internal Server Error";
    }

    return(
        <div className="errorWrap">
            <div className="errorBgWrap">
                <img className="errorBg" src={process.env.PUBLIC_URL + "/images/errorBg.png"} alt="" />
            </div>
            <div className="errorContainer">
                <h3>{contentsTitl}</h3>
                <h1 data-text={errorCd}>{errorCd}</h1>
                <p>
                    {langData&&langData.COMM_MAIN_ERROR_MAIN_LBL_00}
                    <br />
                    {langData&&langData.COMM_MAIN_ERROR_MAIN_LBL_01}
                </p>
                <Link className="homeBtn" to="/">
                    {langData&&langData.COMM_MAIN_HOME_MAIN_BTN_00}
                    {/* COMM_MAIN_HOME_MAIN_BTN_00 */}
                </Link>
            </div>
        </div>
    )
}

export default CommErrorUi;